// let { BASE_URLS } = localStorage;

// if (BASE_URLS === undefined) {
//   BASE_URLS = process.env.REACT_APP_API_URL;
// }
const BASE_URLS = process.env.REACT_APP_API_URL;
export const BASE_URL = BASE_URLS;

export const API_URL = BASE_URL + "/api/";
